import React from 'react';
import Type from 'prop-types';
import { FormControl, InputLabel, Select } from '@mui/material';
import { useField } from 'formik';
import { useTranslation } from 'hooks';
import { CascadeReportAction } from 'constants/actions';

const ActionField = (props) => {
  const { name, required } = props;
  const { t } = useTranslation();
  const [field] = useField(name);
  const labelText = t('selectAction');
  const labelId = `${name}-label`;

  return (
    <FormControl margin="normal" fullWidth required={required}>
      <InputLabel id={labelId}>{labelText}</InputLabel>
      <Select
        labelId={labelId}
        label={labelText}
        native
        {...field}
        inputProps={{ id: `${name}-native-helper` }}
      >
        <option value={CascadeReportAction.SEND_EMAIL}>{t('sendToEmail')}</option>
        <option value={CascadeReportAction.DOWNLOAD_FILE}>{t('downloadFile')}</option>
      </Select>
    </FormControl>
  );
};

ActionField.propTypes = {
  name: Type.string.isRequired,
  required: Type.bool,
};

ActionField.defaultProps = {
  required: false,
};

export default ActionField;
